<div class="sidebar-inner-content">
  <p-table id="providersList" #dt1 selectionMode="multiple" [(selection)]="selectedProviders" [scrollable]="true"
           scrollHeight="400px" [virtualScroll]="true" [virtualScrollItemSize]="46"[value]="providers" [rowHover]="true"
           (onRowSelect)="selectedProvider($event)" (onRowUnselect)="unselectedProvider($event)"
           [lazy]="false" dataKey="name">
    <ng-template pTemplate="caption">
      <div class="flex search-header">
        <span class="p-input-icon-left col-12">
                <input class="header-search" pInputText type="text" (input)="filter(dt1, $event)"
                       placeholder="Search keyword"/>
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="width:60px;"></th>
        <th></th>
        <th style="width:60px;">
          <button class="btn-custom-outlined" (click)="toggleAll()" [style.visibility]="isSearching ? 'hidden' : 'visible'">
            {{ allProvidersHidden ? 'Show all' : 'Hide all' }}
          </button>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-provider>
      <tr [pSelectableRow]="provider" class="p-selectable-row">
        <td style="width:60px;">
          <button type="button"
            pButton
            [style.backgroundImage]="'url(' + (provider.base64Icon | processIcon | async) + ')'"
            [style.backgroundColor]="provider.color"
            class="p-button-rounded provider-color-btn"
            (click)="op.toggle($event)"
          >
            <img *ngIf="provider.base64Icon" [src]="provider.base64Icon" class="provider-image"/>
          </button>
          <div class=""></div>
          <p-popover #op [appendTo]="'body'" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
                     (onHide)="onHide()">
              <ng-template pTemplate="content">
                <div class="color-picker-container">
                  <p-colorPicker
                     (onChange)="colorChanged($event, provider)"
                     [(ngModel)]="provider.color"
                     [inline]="true">
                  </p-colorPicker>
                  <div class="image-upload-section">
                    <div class="map-preview">
                      <div
                      [style.backgroundImage]="provider.base64Icon ? 'url(' + provider.base64Icon + ')' : 'none'"
                      [style.backgroundColor]="provider.color"
                      class="image-preview"
                      >
                    </div>
                    <p [style.color]="provider.color"
                       class="color-display"
                       tooltipPosition="top">
                       {{provider.color | uppercase }}
                       <i class="pi pi-info-circle"  pTooltip="Color used as background for PNG images with transparency and for AZ ID (text label, circle)."></i>
                    </p>
                  </div>
                    <input
                      type="file"
                      accept="image/*"
                      (change)="onImageSelected($event, provider)"
                      style="display: none"
                      #fileInput>
                      <button
                        pButton
                        type="button"
                        [label]="provider.base64Icon ? 'Change image' : 'Upload image'"
                        icon="pi pi-upload"
                        class="p-button-secondary p-button-sm"
                        (click)="fileInput.click()">
                      </button>
                      <button
                        *ngIf="provider.base64Icon"
                        pButton
                        type="button"
                        icon="pi pi-trash"
                        class="p-button-danger p-button-sm"
                        pTooltip="Delete image"
                        [style.marginLeft]="'1rem'"
                        tooltipPosition="top"
                        (click)="removeImage(provider)">
                      </button>
                  </div>
                </div>
              </ng-template>
          </p-popover>
        </td>
        <td>
          {{provider.name}}
          <span *ngIf="isTemporaryProvider(provider)"
                class="temp-provider-badge"
                pTooltip="Temporary provider - will be saved when map is saved"
                tooltipPosition="top">
            (Temp)
          </span>
        </td>
        <td style="width:60px;">
          <a (click)="hideProvider([provider], provider.isVisible)"
             style="cursor:pointer;text-decoration: none;margin-top: 3px;"
             [class]="!provider.isVisible ? 'pi pi-eye-slash' : 'pi pi-eye'">
          </a>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
